import { useCallback } from 'react';

import { useSettings } from '@/data/Settings';
import { useTrackException } from 'presentation/events/hooks/useTrackException';
import { setCookieCAPI } from 'presentation/events/utils/eventCookieUtils';

import { TrackViewItemProps } from './types';
import { useTrackViewItemFacebook } from './useTrackViewItemFacebook';
import { useTrackViewItemGA4 } from './useTrackViewItemGA4';
import { useTrackViewItemPinterest } from './useTrackViewItemPinterest';
import { useTrackViewItemTikTok } from './useTrackViewItemTikTok';

export const useTrackViewItem = () => {
	const { settings } = useSettings();
	const { storeId } = settings;
	const trackException = useTrackException();

	const sendGA4Event = useTrackViewItemGA4();
	const { sendFacebookEvent } = useTrackViewItemFacebook();
	const { sendPinterestEvent } = useTrackViewItemPinterest();
	const { sendTikTokEvent } = useTrackViewItemTikTok();

	return useCallback(
		({ items, product, bundleId, personInfo }: TrackViewItemProps) => {
			try {
				const products = items ?? [product];
				const eventId = setCookieCAPI('mfbt');

				sendGA4Event({ products, bundleId });

				sendFacebookEvent({ eventId, products, bundleId, personInfo, storeId });

				sendPinterestEvent({ eventId, products, bundleId, personInfo, storeId });

				sendTikTokEvent({ eventId, products, bundleId, personInfo, storeId });
			} catch (e) {
				console.error('Error sending view item event', e);
				trackException(e);
			}
		},
		[sendGA4Event, sendFacebookEvent, sendPinterestEvent, sendTikTokEvent, storeId, trackException]
	);
};
